/* ===== Required CSS ===== */
import './styles/index.css';

/* ===== Required Modules ===== */
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';

/* ===== Required Others ===== */
import { App } from './App';
import { i18n, persistor, store } from '@umanforge/common';
import { ToastProvider } from '@common_provider/toast.provider';

import 'dayjs/locale/bg';
import 'dayjs/locale/cs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/hu';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt';
import 'dayjs/locale/ro';
import 'dayjs/locale/sk';
import 'dayjs/locale/sv';
import { PersistGate } from 'redux-persist/integration/react';


/*
 * Composant racine pour gérer l'initialisation et le chargement
 */
const Root = () => {
  const [ isReady, setIsReady ] = useState<boolean>( false );

  useEffect( () => {
    const onInitialized = () => { return setIsReady( true ); };

    // Si i18n est déjà initialisé, on le marque comme prêt immédiatement
    if ( i18n.isInitialized ) {
      setIsReady( true );
    } else {
      // Sinon, on attend qu'il soit initialisé et on change l'état
      i18n.on( 'initialized', onInitialized );
    }

    // Nettoyage de l'effet : on retire l'écouteur d'événement lors du démontage
    return () => {
      i18n.off( 'initialized', onInitialized );
    };
  }, [] );  // Ce useEffect ne dépend de rien, il est appelé une seule fois au montage

  // Si i18n n'est pas encore prêt, on affiche l'écran de chargement
  if ( !isReady ) {
    return <div>Loading...</div>;
  }

  return (
    <I18nextProvider i18n={i18n}>
      <App />
      <ToastProvider />
    </I18nextProvider>
  );
};

// Création du root element pour le rendu de l'application
const root = ReactDOM.createRoot( document.getElementById( 'root' ) as HTMLElement );

root.render(
  <Provider store={ store }>
    <PersistGate loading={ <div></div> } persistor={ persistor }>
      <Root />
    </PersistGate>
  </Provider>
);